import { render, staticRenderFns } from "./EvictionTable.vue?vue&type=template&id=1b927288&scoped=true&"
import script from "./EvictionTable.vue?vue&type=script&lang=js&"
export * from "./EvictionTable.vue?vue&type=script&lang=js&"
import style0 from "./EvictionTable.vue?vue&type=style&index=0&id=1b927288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b927288",
  null
  
)

export default component.exports